import { render, staticRenderFns } from "./pdfViewer.vue?vue&type=template&id=a3f5a566&scoped=true&"
import script from "./pdfViewer.vue?vue&type=script&lang=ts&"
export * from "./pdfViewer.vue?vue&type=script&lang=ts&"
import style0 from "./pdfViewer.vue?vue&type=style&index=0&id=a3f5a566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f5a566",
  null
  
)

export default component.exports